











 

















const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoveReflectTemplateMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReflectTemplate",
      "kind": "LinkedField",
      "name": "reflectTemplate",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RetrospectiveMeetingSettings",
      "kind": "LinkedField",
      "name": "retroMeetingSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "selectedTemplateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReflectTemplate",
          "kind": "LinkedField",
          "name": "selectedTemplate",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RemoveReflectTemplatePayload",
  "abstractKey": null
};
})();

(node ).hash = "37252944e83080d4ceddbb4bd43e778c";

export default node;
